import PasskeyPanel from "./PasskeyPanel";
import ChangePassword from "./ChangePassword";
import LanguagePicker from "./LanguagePicker";
import { useT } from "./i18n";
import type { User } from "./api";

/**
 * Settings in a view of their own.
 *
 * They used to sit above the home screen and push the tool down: two things
 * done once in a while covering the one thing used every day.
 */
export default function Settings({
  user,
  onBack,
  onLogout,
  onAuthError,
}: {
  user: User | null;
  onBack: () => void;
  onLogout: () => void;
  onAuthError: (err: unknown) => boolean;
}) {
  const t = useT();
  return (
    <main className="mx-auto max-w-2xl px-5 py-8">
      <header className="mb-8 border-b-2 border-current pb-5">
        <button
          type="button" onClick={onBack}
          className="-ml-1 inline-flex items-center gap-1.5 rounded px-1 py-1 text-sm opacity-70 hover:opacity-100"
        >
          <span aria-hidden="true">←</span> {t("app.back")}
        </button>
        <h1 className="mt-3 flex items-center gap-3 text-3xl font-semibold tracking-tight">
          <img src="/icon.svg" alt="" width="34" height="34" className="rounded-[8px]" />
          {t("settings.title")}
        </h1>
        <p className="mt-2 opacity-70">{user?.email}</p>
      </header>

      <div className="flex flex-col gap-5">
        <PasskeyPanel onAuthError={onAuthError} />
        <ChangePassword />
        <LanguagePicker />

        <section className="rounded border border-current/20 p-5">
          <h2 className="text-xs font-semibold uppercase tracking-widest opacity-60">
            {t("app.signOut")}
          </h2>
          <button
            type="button" onClick={onLogout}
            className="mt-4 rounded border border-current/25 px-5 py-2.5 font-semibold hover:bg-current/10"
          >
            {t("app.signOut")}
          </button>
        </section>
      </div>
    </main>
  );
}
